import MenuItem from '@app/components/MenuItem'
import ModalUpdateStatusCampaign from '@app/components/ModalUpdateStatusCampaign'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import EditIcon from '@mui/icons-material/Edit'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import { InputAdornment, OutlinedInput } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SwiperCore, { Navigation, Pagination } from 'swiper'
import CustomChip from '../../../../components/atoms/CustomChip/CustomChip'
import Section from '../../../../components/atoms/Section/Section'
import CardWidget from '../../../../components/CardWidget'
import ImageSlider from '../../../../components/ImageSlider'
import OptionMenu from '../../../../components/OptionMenu'
import useRemember from '../../../../libs/useRemember'

const IconButtonCustom = styled(IconButton)((props) => {
  const { theme } = props
  if (!props['aria-expanded']) {
    return {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    }
  }
  return {
    transform: 'rotate(180deg)',
  }
})

const GirdCustom = styled(Grid)({
  alignItems: 'center',
  margin: 10,
})

const PartnerDetail = (props) => {
  const {
    id,
    name,
    email,
    phone,
    address,
    status,
    description,
    campaigns_count,
    vouchers_count,
    images,
    logo,
    favicon,
  } = props.partner

  const [showKey, setShowKey] = useState(false)

  const handleEventMouse = (event) => {
    event.preventDefault()
    if (0 === event.button) {
      if ('mousedown' === event.type) {
        setShowKey(true)
      } else {
        setShowKey(false)
      }
    }
  }

  const [text, setText] = useState(props.secret_key)

  const inputHandler = (event) => {
    setText(event.target.value)
  }

  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      enqueueSnackbar(t('ALERT.COPY_SUCCESS'), {
        variant: 'success',
      })
    } catch {
      enqueueSnackbar(t('ALERT.COPY_FAIl'), {
        variant: 'warning',
      })
    }
  }

  SwiperCore.use([Pagination, Navigation])
  const { t } = useTranslation()

  const [allExpandedPartner, setAllExpandedPartner] = useRemember(`PartnerDetail:${id}`, {
    description: true,
    logo: true,
    integration: true,
  })

  const handleExpand = (attribute) => {
    setAllExpandedPartner({ ...allExpandedPartner, [attribute]: !allExpandedPartner[attribute] })
  }

  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const [openModalConfirm, setOpenModalConfirm] = useState(false)
  const [modalName, setModalName] = useState('')
  const handleCloseModal = () => setOpenModalConfirm(false)

  const renderModal = (modalName) => {
    switch (modalName) {
      case 'ActiveOrDeactive':
        return (
          <ModalUpdateStatusCampaign
            content={'active' === status ? t('MODAL.DEACTIVE_CONTENT_PARTNER') : t('MODAL.ACTIVE_CONTENT_PARTNER')}
            handleCloseModal={handleCloseModal}
            handleSubmit={() =>
              Inertia.get(
                route('admin.partners.status.change', {
                  partner: id,
                  status: 'active' === status ? 'inactive' : 'active',
                })
              )
            }
            openModalConfirm={openModalConfirm}
            title={'active' === status ? t('MODAL.DEACTIVE_PARTNER') : t('MODAL.ACTIVE_PARTNER')}
          />
        )
      case 'GenerateKey':
        return (
          <ModalUpdateStatusCampaign
            content={t('MODAL.GENERATE_KEY_CONTENT')}
            handleCloseModal={handleCloseModal}
            handleSubmit={() => Inertia.get(route('admin.partners.generate', { partner: id }))}
            openModalConfirm={openModalConfirm}
            title={t('MODAL.GENERATE_KEY')}
          />
        )
      default:
        return null
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item md={4} sm={12} xs={12}>
              <ImageSlider images={images} />
            </Grid>
            <Grid item md={8} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={11}>
                  <Typography variant="h4">{name}</Typography>
                </Grid>
                <Grid item style={{ display: 'flex', justifyContent: 'flex-end' }} xs={1}>
                  <OptionMenu
                    anchorEl={anchorEl}
                    handleClick={handleClick}
                    handleClose={handleClose}
                    open={null !== anchorEl}
                  >
                    <MenuItem
                      component={InertiaLink}
                      href={route('admin.partners.edit', id)}
                      icon={EditIcon}
                      name={t('BUTTON.EDIT')}
                    />
                    <MenuItem
                      icon={'active' === status ? LockIcon : LockOpenIcon}
                      name={'active' === status ? t('PARTNER.INACTIVE') : t('PARTNER.ACTIVE_ACTION')}
                      onClick={() => {
                        handleClose()
                        setModalName('ActiveOrDeactive')
                        setOpenModalConfirm(true)
                      }}
                    />
                    <MenuItem
                      icon={VpnKeyIcon}
                      name={t('BUTTON.GENERATE_KEY')}
                      onClick={() => {
                        handleClose()
                        setModalName('GenerateKey')
                        setOpenModalConfirm(true)
                      }}
                    />
                  </OptionMenu>
                </Grid>
                {renderModal(modalName)}
                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('PARTNER.EMAIL')}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1">{email}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('PARTNER.PHONE')}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1">{phone}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('PARTNER.ADDRESS')}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Typography variant="body1">{address}</Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.STATUS')}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomChip color={status} label={t(`CAMPAIGN.${status?.toUpperCase()}`)} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('PARTNER.INTEGRATION')}
                <IconButtonCustom
                  aria-expanded={allExpandedPartner.integration}
                  aria-label="show more"
                  onClick={() => handleExpand('integration')}
                >
                  <ExpandMoreIcon />
                </IconButtonCustom>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedPartner.integration} timeout="auto">
                <Grid container spacing={2}>
                  <Grid item xs={3}>
                    <Grid container alignContent="center" justifyContent="flex-start" style={{ height: '100%' }}>
                      <Typography color="textSecondary" variant="body1">
                        {t('PARTNER.SECRET_KEY')}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid container alignItems="flex-start">
                      <Grid item xs={12}>
                        {props.secret_key ? (
                          <OutlinedInput
                            readOnly
                            endAdornment={
                              <InputAdornment position="end">
                                <Grid container spacing={4}>
                                  <Grid item xs={6}>
                                    <IconButton onClick={handleCopy}>
                                      <ContentCopyIcon />
                                    </IconButton>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <IconButton
                                      aria-label="toggle password visibility"
                                      edge="end"
                                      onMouseDown={handleEventMouse}
                                      onMouseUp={handleEventMouse}
                                    >
                                      {showKey ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                  </Grid>
                                </Grid>
                              </InputAdornment>
                            }
                            sx={{
                              '& .MuiOutlinedInput-notchedOutline ': {
                                border: 'none',
                              },
                              '& .MuiInputBase-inputAdornedEnd': {
                                width: '600px',
                              },
                            }}
                            type={showKey ? 'text' : 'password'}
                            value={props.secret_key}
                            onChange={inputHandler}
                          />
                        ) : (
                          t('PARTNER.NOT_SET')
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('CAMPAIGN.IMAGES')}{' '}
                <IconButtonCustom
                  aria-expanded={allExpandedPartner.logo}
                  aria-label="show more"
                  onClick={() => handleExpand('logo')}
                >
                  <ExpandMoreIcon />
                </IconButtonCustom>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedPartner.logo} timeout="auto">
                <GirdCustom container item spacing={2} xs={6}>
                  <Grid item xs={3}>
                    <Typography variant="body2">{t('PARTNER.LOGO')}</Typography>
                  </Grid>
                  <img src={logo?.link} width={300} />
                </GirdCustom>
                <GirdCustom container item spacing={2} xs={6}>
                  <Grid item xs={3}>
                    <Typography variant="body2">{t('PARTNER.FAVICON')}</Typography>
                  </Grid>
                  <img src={favicon?.link} width={100} />
                </GirdCustom>
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <CardWidget
              button={t('PARTNER.VIEW_ALL')}
              color="warning"
              href={route('admin.campaigns.index', { partner_id: id, partner_name: name })}
              primary={campaigns_count}
              title={t('CAMPAIGN.TOTAL_CAMPAIGNS')}
            ></CardWidget>
          </Grid>
          <Grid item xs={6}>
            <CardWidget color="danger" primary={vouchers_count} title={t('CAMPAIGN.TOTAL_VOUCHERS')}></CardWidget>
          </Grid>
        </Grid>
      </Grid>

      {props.voucherByType.map((item, index) => (
        <Grid item key={index} xs={12}>
          <Section>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5">{t(`CODES.${item.type.toUpperCase()}`)} </Typography>
              </Grid>
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget color="info" primary={item.amount_codes} title={t('CAMPAIGN.TOTAL_CODES')}></CardWidget>
              </Grid>

              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget
                  color="success"
                  primary={item.redeemed_codes}
                  title={t('CAMPAIGN.REDEEMED_CODES')}
                ></CardWidget>
              </Grid>

              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget color="danger" primary={item.used_codes} title={t('CAMPAIGN.USED_CODES')}></CardWidget>
              </Grid>
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget color="info" primary={item.count_voucher} title={t('CAMPAIGN.TOTAL_VOUCHERS')}></CardWidget>
              </Grid>

              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget color="info" primary={item.total_cost} title={t('CAMPAIGN.TOTAL_COST')}></CardWidget>
              </Grid>
            </Grid>
          </Section>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('CAMPAIGN.DESCRIPTION')}{' '}
                <IconButtonCustom
                  aria-expanded={allExpandedPartner.description}
                  aria-label="show more"
                  onClick={() => handleExpand('description')}
                >
                  <ExpandMoreIcon />
                </IconButtonCustom>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Collapse unmountOnExit in={allExpandedPartner.description} timeout="auto">
                {description ? (
                  <Typography
                    dangerouslySetInnerHTML={{ __html: description }}
                    style={{ wordBreak: 'break-all' }}
                    variant="body1"
                  ></Typography>
                ) : (
                  <Typography color="textSecondary" variant="body1">
                    {t('PARTNER.NOT_SET')}
                  </Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Grid>
  )
}

export default PartnerDetail
